// This will be the header unit for the wizard layout.
import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import moment from 'moment';
import ServiceForm from './../../newServiceForm';
import { HTTPService } from "./../../../services/httpService";
import ReactGA from 'react-ga4';
import { SharedRequestPricing, SharedPricingUtils } from './../services/sharedPricingCalculations';


const API = new HTTPService();

class EditJob extends Component {

  constructor(props) {

    super(props);

    this.state = {
      redirect: false,
      currentStep: 99,
      platformFee : 0.05,
      customer: "",
      customerName:"",
      customerType:"",
      vehicle: {},
      services: [],
      total : 0,
      discount : 0,
      jobType : "Retail",
      fee : 0,
      loading:false,
      notes:"",
      taxRate : 0,
      taxPercent : 0,
      availableDate: new moment().startOf('day'),
      dueDate: new moment().startOf('day'),
      user: this.props.user,
      authenticated : 0,
      originalDealerId: null,
    };
    
    this.handleChange = this.handleChange.bind(this);
    this.handleServices = this.handleServices.bind(this);
    
  }

async componentDidMount() {
    
  let installerRequest = "/installerLocations/"+this.props.typeId;
  const  { data : installers }  =  await API.get(installerRequest);

  let taxRate = { percentage: 0 };
  if (installers[0] && installers[0].stripe_tax_rate) {
    let taxRequest = "/taxes/"+installers[0].stripe_tax_rate;
    ({ data: taxRate } = await API.get(taxRequest));
  } else {
    console.error(
      `[editJob] Missing stripe_tax_rate for installer ${this.props.typeId}`,
      `location_id=${installers[0] && (installers[0].location_id || installers[0].Location_id)}.`,
      `Tax rate must be configured on installer_locations — defaulting to 0% is NOT correct.`
    );
  }

  let fullRequest = `/requestimates/requestbyID/?Id=${this.props.match.params.requestId}`;        
  const  { data : requests }  =  await API.get(fullRequest);

  // 🎯 NEW: User type and job type logic
  const jobType = requests[0].Request_type;     // "dealer" or "installer"
  const userType = this.props.userType;        // "dealer" or "installer"
  let serviceFormUserType, serviceFormTypeId, customerType, originalDealerId = null;

  if (jobType === "dealer") {
      originalDealerId = requests[0].Requestor;
      
      if (userType === "dealer") {
          // Dealer editing their dealer job = dealer features
          serviceFormUserType = "dealer";
          serviceFormTypeId = originalDealerId;
      } else {
          // Installer editing dealer job = wholesale view
          serviceFormUserType = "installer";
          serviceFormTypeId = this.props.typeId;
      }
      customerType = "WHOLE";
  } else {
      // Retail job = always installer (dealers never see these)
      serviceFormUserType = "installer";
      serviceFormTypeId = this.props.typeId;
      customerType = "RETAIL";
  }

  let vehicleRequest = `/vehicles/${requests[0].vin}`;        
  const  { data : vehicles }  =  await API.get(vehicleRequest);

  let serviceRequest = `/requestService/${this.props.match.params.requestId}`;
  console.log("🔍 EDIT JOB DEBUG - API endpoint:", serviceRequest);
  console.log("🔍 EDIT JOB DEBUG - Request ID:", this.props.match.params.requestId);

  const  { data : services }  =  await API.get(serviceRequest);

  // 🔍 DEBUG: Log the full services object retrieved from database
  console.log("🔍 EDIT JOB DEBUG - Services retrieved from database:", JSON.stringify(services, null, 2));
  console.log("🔍 EDIT JOB DEBUG - Number of services:", services.length);
  console.log("🔍 EDIT JOB DEBUG - Service IDs:", services.map(s => s.id || s.service_id || 'NO_ID'));
  console.log("🔍 EDIT JOB DEBUG - Service Names:", services.map(s => s.service_name || s.description || 'NO_NAME'));

  for (let i=0; i < services.length; i++){
    if (services[i].custom_description){
      services[i].description = services[i].custom_description;
    }

    // Ensure required fields exist with defaults
    services[i].service_discount = services[i].service_discount || 0;
    services[i].duration_days = services[i].duration_days || 0;

    // Keep service_amount for any backend compatibility
    services[i].service_amount = services[i].service_amount || 0;

    // Preserve quantity fields from database
    services[i].quantity = services[i].quantity || 1;
    services[i].unit_price = services[i].unit_price || services[i].service_amount || 0;
    services[i].allow_multiple = services[i].allow_multiple || 0;

    // Compute _uid from the database id (PK)
    services[i]._uid = services[i].id || `legacy_${i}`;
  }  

  let calendarRequest = `/installerCalendarRequest/${this.props.match.params.requestId}`;        
  const  { data : calendar }  =  await API.get(calendarRequest);

  let authRequest = `/installerAuth/${this.props.typeId}`;        
  const  { data : auths }  =  await API.get(authRequest);

  // Vehicle size comes from id_car_type field
  let vehicle = vehicles[0];
  if (vehicle && vehicle.id_car_type) {
      vehicle.size = vehicle.id_car_type;
  }
  
  // 🎯 UPDATED: setState with new calculated values
  this.setState({
      vehicle: vehicle,
      auth : auths[0],
      taxPercent : taxRate.percentage,
      services,
      calendar,
      eventId : calendar && calendar[0] ? calendar[0].event_id : null,
      jobType : jobType, 
      installer : installers[0], 
      request : requests[0], 
      total : requests[0].Request_Total, 
      discount : requests[0].Request_Discount, 
      customerType : customerType,              // NEW: calculated customerType
      serviceFormUserType: serviceFormUserType, // NEW: calculated user type
      serviceFormTypeId: serviceFormTypeId,     // NEW: calculated type ID
      originalDealerId: originalDealerId        // NEW: dealer ID when applicable
  });
}; // 🎯 FIXED: Added missing closing brace

  /* Processing to do to update the job in the database */

handleSubmit = async e => {
  e.preventDefault();

  try {
    console.log("Starting handleSubmit with state:", this.state);

    if (!this.state.services || this.state.services.length === 0) {
      throw new Error("No services to save");
    }

    // Validate pricing data using shared module
    const validationResult = SharedPricingUtils.validatePricingData(this.state.services);
    if (!validationResult.isValid) {
      console.error("Pricing validation errors:", validationResult.errors);
      throw new Error(`Pricing validation failed: ${validationResult.errors.join(', ')}`);
    }

    this.setState({ loading: true });

    // Check if any service is protected (has been worked on or has materials)
    const isServiceProtected = (service) => {
      const hasWorkStarted = service.service_state === 'started' || service.service_state === 'finished';
      const hasMaterials = service.materials?.length > 0;
      return hasWorkStarted || hasMaterials;
    };

    // Mark protected services and preserve all their original data
    const servicesWithProtection = this.state.services.map(service => ({
      ...service,
      _isProtected: isServiceProtected(service),
      materials: service.materials,
      service_state: service.service_state,
      started_at: service.started_at,
      started_by: service.started_by,
      finished_at: service.finished_at,
      finished_by: service.finished_by
    }));

    // UPDATED: Use shared pricing module for consistent calculations
    const submissionData = SharedPricingUtils.prepareForSubmission(servicesWithProtection, {
      jobType: this.state.jobType,
      taxRate: this.state.taxPercent
    });

    console.log("Calculated pricing breakdown:", submissionData.breakdown);

    // Prepare the request data
    let newRequest = { ...this.state.request };
    
    // UPDATED: Apply calculated values from shared module
    newRequest.Request_Total = submissionData.calculatedTotals.Request_Total;
    newRequest.Request_Discount = submissionData.calculatedTotals.Request_Discount;
    newRequest.Request_Fee = submissionData.calculatedTotals.Request_Fee;         // NEW: Post-discount fee
    newRequest.Request_taxes = submissionData.calculatedTotals.Request_taxes;
    newRequest.request_duration = submissionData.calculatedTotals.request_duration;

    // Service description (unchanged)
    newRequest.Service_Requested = this.state.services[0].service_category + " - " + this.state.services[0].description;
    if (this.state.services.length > 1) {
      newRequest.Service_Requested = newRequest.Service_Requested + " + " + (this.state.services.length-1);
    }
    
    newRequest.due_date = new moment(newRequest.available_date).add(newRequest.request_duration, "days").format("YYYY-MM-DD HH:mm:ss"); 
    newRequest.created_date = new moment(newRequest.created_date).format("YYYY-MM-DD HH:mm:ss"); 
    newRequest.available_date = new moment(newRequest.available_date).format("YYYY-MM-DD HH:mm:ss"); 

    // Prepare all data for the transaction call
    const transactionData = {
      requestData: newRequest,
      services: submissionData.services,
      calendar: this.state.calendar,
      eventId: this.state.eventId,
      installer: this.state.installer,
      auth: this.state.auth,
      // Include the pricing breakdown for debugging
      pricingBreakdown: submissionData.breakdown,
      // User info for audit trail
      userId: this.props.user?.User_id,
      userType: this.props.userType || 'installer'
    };

    console.log("Sending transaction data:", transactionData);

    // Rest of handleSubmit unchanged...
    await API.put(
      `/requestimates/${this.state.request.Request_id}/update-transaction`,
      transactionData
    );

    ReactGA.event({category: 'Installer', action: 'Updated Estimate', label: 'prod'});
    alert("Job updated successfully!");

    const currentState = this.state.request.current_state;
    if (currentState === "collected") {
      window.location = '/financials';
    } else if (currentState === "new") {
      window.location = '/requestimates';
    } else if (currentState === "received" || currentState === "started") {
      window.location = '/jobs?filter=inprogress';
    } else {
      window.location = '/jobs?filter=scheduled';
    }

  } catch (error) {
    console.error("Error updating job:", error);

    let errorMessage = "There was an error updating the job. Please try again.";
    if (error.response && error.response.data && error.response.data.message) {
      errorMessage = error.response.data.message;
    }

    alert(errorMessage);

  } finally {
    this.setState({ loading: false });
  }
};

  // Use the submitted data to set the state
  handleChange(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value
    })
  }

  handleCancel = e => {
    e.preventDefault();
    ReactGA.event({category: 'Installer', action: 'Cancel Edit', label: 'prod'});
    const currentState = this.state.request.current_state;
    if (currentState === "collected") {
      window.location = '/financials';
    } else if (currentState === "new") {
      window.location = '/requestimates';
    } else if (currentState === "received" || currentState === "started") {
      window.location = '/jobs?filter=inprogress';
    } else {
      window.location = '/jobs?filter=scheduled';
    }
    return;
  }

  // Add this method to your EditJob component class

handleVehicleCancelFromEdit = () => {
  // This will be called when user cancels vehicle selection in edit mode
  ReactGA.event({category: 'Installer', action: 'Cancel Edit via Vehicle Selection', label: 'prod'});

  const currentState = this.state.request.current_state;
  if (currentState === "collected") {
    window.location = '/financials';
  } else if (currentState === "new") {
    window.location = '/requestimates';
  } else if (currentState === "received" || currentState === "started") {
    window.location = '/jobs?filter=inprogress';
  } else {
    window.location = '/jobs?filter=scheduled';
  }
};

async handleServices(services, total, discount) {
  console.log("handleServices called with:", { services, total, discount });
  
  // Use shared module to validate the totals
  const calculatedTotal = SharedRequestPricing.calculateRequestTotal(services);
  const calculatedDiscount = SharedRequestPricing.calculateRequestDiscount(services);
  
  if (Math.abs(total - calculatedTotal) > 0.01 || Math.abs(discount - calculatedDiscount) > 0.01) {
    console.warn("Total mismatch detected:", {
      passedTotal: total,
      calculatedTotal: calculatedTotal,
      passedDiscount: discount,
      calculatedDiscount: calculatedDiscount
    });
  }
  
  // Store services and use consistent calculated values
  this.setState({ 
    services, 
    total: calculatedTotal,      // Use shared calculation
    discount: calculatedDiscount // Use shared calculation
  }, () => {
    console.log("State updated with shared pricing:", this.state);
  });
}
  readAuth = async (installerId) => {
    let installerRequest = `/installerAuth/${installerId}`;        
    const  { data : installer }  =  await API.get(installerRequest);
    this.setState( {authenticated : installer[0].authenticated});
  }
    
render() {

  ReactGA.send({ hitType: "pageview", page: "/editJob" })
  let displayType = "Retail";
  if (this.state.jobType === "dealer")
    displayType = "Wholesale";

return (
    <React.Fragment>
      <div className="bg-white border border-secondary">
        <div className="col-lg-12 text-right">
          <button className="btn" type="button" onClick={this.handleCancel}>
            <i className="fa-sharp fa-solid fa-xmark"></i>
          </button>
        </div>

        <div className="col-lg-12 d-flex justify-content-center">
          <h3>Update {displayType} services on {this.state.vehicle.Make} {this.state.vehicle.Model}</h3>
        </div>

        <div className="col-lg-12 p-0">
          <ServiceForm
              userType={this.state.serviceFormUserType}        // NEW: use calculated value
              typeId={this.state.serviceFormTypeId}            // NEW: use calculated value
              specialist={this.props.typeId}                   // SAME: always current installer
              currentStep={this.state.currentStep}
              handleServices={this.handleServices}
              total={this.state.total}
              customerType={this.state.customerType}           // NEW: calculated customerType
              vehicle={this.state.vehicle}
              discount={this.state.discount}
              category={"Paint"}
              services={this.state.services}
              notes={this.state.request}
              requestId={this.props.match.params.requestId}
              installerId={this.props.typeId}
          />
        </div>
        <div className="m-5 d-flex justify-content-center">
          <button
            type="button"
            disabled={this.state.services.length === 0 || this.state.loading}
            onClick={this.handleSubmit}
            className="jv-btn jv-btn-primary"
          >
            {this.state.loading ? 'Updating...' : 'Update'}
          </button>
          <button type="button" onClick={this.handleCancel} className="jv-btn jv-btn-tertiary">Cancel</button>
        </div>

      </div>
    </React.Fragment>
  );
};

}

export default withRouter(EditJob);